/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconDownload,
  IconPlus,
  IconAdjustmentsHorizontal,
  IconRefresh,
} from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import AllOrderTable from "./AllOrderTable";
import FilterSidebar from "./FilterSidebar";
import AddOrdersModals from "./AddOrdersModals";
import EditOrderModal from "./EditOrderModal";
import { useNavigate } from "react-router-dom";
import {
  useFetchDeleteOrdersData,
  useFetchOrdersData,
  useOrderDeleteMutation,
  useOrderSyncMutation,
  useOrderUpdateMutation,
} from "../../../apis/orderApis";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { OrderFormData } from "../../../types/types";
import useDebounce from "../../../utilities/useDebounce";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import RoleToggle from "../../../components/RoleToggle";
import NoDataFound from "../../../components/common/NoDataFound";
import EntriesSelector from "../../../components/common/EntriesSelector";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";

type Props = {
  pending?: boolean;
};

export default function AllOrders({ pending }: Props) {
  const [showModal, setShowModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const toggleFilter = () => setShowFilter(!showFilter);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isReverseOrderWiseOpen, setIsReverseOrderWiseOpen] = useState(false);
  const [isRevertOrder, setIsRevertOrder] = useState(false);
  const [isSmsOpen, setIsSmsOpen] = useState(false);
  const [isForword3PlOpen, setIsForword3PlOpen] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [order, setOrder] = useState<any>();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState<any[]>([]);

  const openForword3PlModal = (order: any) => {
    setOrder(order);
    setIsForword3PlOpen(true);
  };
  const closeForword3PlModal = () => setIsForword3PlOpen(false);
  const openSmsModal = () => setIsSmsOpen(true);
  const closeSmsModal = () => setIsSmsOpen(false);
  const openEditModal = (data: any) => {
    setOrder(data);
    setIsEditOpen(true);
  };
  const [orderItemId, setOrderItemId] = useState<any>(null);
  const [openResponse, SetOpenResponse] = useState<boolean | string>(false);
  const [orderBulkResponse, setOrderBulkResponse] = useState<any>(null);
  const closeEditModal = () => setIsEditOpen(false);
  const { mutate: deleteMutate, isPending: isDeletePending } =
    useOrderDeleteMutation(order?.id ?? "");
  const { mutate: syncMutate } = useOrderSyncMutation();
  const { mutate: updateMutate, isPending: isUpdatePending } =
    useOrderUpdateMutation(order?.id ?? "");
  const [filters, setFilters] = useState<string[]>([]);

  const tabs = ["All"];
  //  "Deleted", "Cancelled"

  const [activeTab, setActiveTab] = useState<string>(
    () => localStorage.getItem("orderTabActiveRole") || "All",
  );
  useEffect(() => {
    localStorage.setItem("orderTabActiveRole", activeTab);
  }, [activeTab]);

  const {
    // data: orders,
    isPending: listPending,
    refetch,
  } = useFetchOrdersData(pageNo, searchFor, limit, filters);

  const orders = useSelector((state: any) => state.orders.list);

  const {
    data: deletedOrders,
    isPending: deletedOrderslistPending,
    refetch: fetchDeletedOrders,
  } = useFetchDeleteOrdersData(pageNo, searchFor);

  const openDeleteModal = (data: any) => {
    setOrder(data);
    setIsDeleteOpen(true);
  };
  const openRevertModal = (data: any) => {
    setOrder(data);
    setIsRevertOrder(true);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  // Refetch correct data when tab/search/page changes
  useEffect(() => {
    if (activeTab === "Deleted") {
      fetchDeletedOrders();
    } else {
      refetch();
    }
  }, [
    debouncedSearchFor,
    pageNo,
    activeTab,
    limit,
    fetchDeletedOrders,
    refetch,
  ]);

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    control,
    handleSubmit,
  } = useForm<OrderFormData>();

  const {
    register: forwardRegister,
    setValue: setForwardValue,
    clearErrors: forwardClearErrors,
    formState: { errors: forwardErrors },
    watch: forwardWatch,
    handleSubmit: handleForwardSubmit,
  } = useForm<any>();

  const {
    register: deleteRegister,
    setValue: deleteSetValue,
    clearErrors: deleteClearErrors,
    formState: { errors: deleteErrors },
    watch: deleteWatch,
    reset: deleteReset,
    handleSubmit: deleteHandleSubmit,
  } = useForm<any>();

  const closeDeleteModal = () => setIsDeleteOpen(false);
  const openReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(true);
  const closeReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(false);
  const closeRevertOrder = () => setIsRevertOrder(false);

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (value: string) => {
    setSelectedOption(value);
    setOpen(false);
    if (value === "NewOrder") setShowModal(true);
  };

  const navigate = useNavigate();

  const [columns, setColumns] = useState([
    { id: 1, text: "Select", value: "select", isShow: false },
    { id: 2, text: "#", value: "sn", isShow: true },
    { id: 3, text: "Order Date", value: "orderDate", isShow: true },
    { id: 4, text: "Platform", value: "platform", isShow: true },
    { id: 5, text: "AWB No.", value: "awbNumber", isShow: true },
    { id: 6, text: "Reference", value: "referenceNumber", isShow: true },
    { id: 7, text: "Route", value: "routeCode", isShow: false },
    { id: 8, text: "Outlet Name", value: "outletName", isShow: true },
    { id: 9, text: "Shipping Details", value: "shippingDetails", isShow: true },
    { id: 10, text: "Origin", value: "origin", isShow: false },
    { id: 11, text: "Destination", value: "destination", isShow: false },
    {
      id: 12,
      text: "Receiver Details",
      value: "receiverDetails",
      isShow: false,
    },
    { id: 13, text: "Payment Details", value: "paymentDetails", isShow: true },
    { id: 14, text: "Date", value: "date", isShow: false },
    { id: 15, text: "No of Attempt", value: "noOfAttempt", isShow: false },
    { id: 16, text: "Item Detail", value: "itemDetail", isShow: false },
    { id: 17, text: "Client", value: "client", isShow: false },
    { id: 18, text: "Status", value: "status", isShow: true },
  ]);

  const syncOrder = () => {
    syncMutate(undefined, {
      onSuccess: () => {
        refetch();
        toast.success("Order synchronized successfully");
      },
      onError: (error: any) => {
        toast.error(error.message || "Failed to sync order");
      },
    });
  };

  const handleUpdateOrder = (data: any) => {
    updateMutate(data, {
      onSuccess: () => {
        setIsEditOpen(false);
        refetch();
        toast.success("Order updated successfully");
      },
      onError: (error: any) => {
        toast.error(error.message || "Failed to update order");
      },
    });
  };

  const handleLabelPrint = (data: any) => {
    setOrder(data);
    setShowLabelModal(true);
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const handleSetHeadings = (value: string | undefined, checked: boolean) => {
    setColumns((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const handleSelectOrder = (order: any) => {
    setSelectedOrders((prev) => {
      if (prev.some((o) => o.id === order.id)) {
        return prev.filter((o) => o.id !== order.id);
      }
      return [...prev, order];
    });
  };

  const handleDownloadXLSX = () => {
    const isDeletedTab = activeTab === "Deleted";
    const dataSource = isDeletedTab ? deletedOrders : orders;

    if (!dataSource || !dataSource.orders || dataSource.orders.length === 0) {
      toast.error("No data available to download");
      return;
    }

    if (!isCheckboxEnabled) {
      setIsCheckboxEnabled(true);
      setColumns((prev) =>
        prev.map((col) =>
          col.value === "select" ? { ...col, isShow: true } : col,
        ),
      );
      return;
    }

    const dataToExport =
      selectedOrders.length > 0 ? selectedOrders : dataSource.orders;

    if (selectedOrders.length === 0 && isCheckboxEnabled) {
      toast.error("Please select at least one order to download");
      return;
    }

    const visibleColumns = columns.filter((col) => col.isShow);

    const data = dataToExport.map((order: any, index: number) => {
      const row: any = {};
      visibleColumns.forEach((col) => {
        if (col.value === "sn") {
          row[col.text] =
            selectedOrders.length > 0
              ? index + 1
              : (pageNo - 1) * limit + (index + 1);
        } else if (col.value === "orderDate") {
          row[col.text] = order.createdAt
            ? new Date(order.createdAt).toLocaleDateString()
            : "";
        } else if (col.value === "platform") {
          row[col.text] = order.platform || "";
        } else if (col.value === "awbNumber") {
          row[col.text] = order.awbNumber || "";
        } else if (col.value === "referenceNumber") {
          row[col.text] = order.referenceNumber || "";
        } else if (col.value === "routeCode") {
          row[col.text] = order.routeCode || "";
        } else if (col.value === "warehouseName") {
          row[col.text] = order.warehouseName || "";
        } else if (col.value === "shippingDetails") {
          row["Shipping Company"] = order.shippingCompany || "";
          row["Shipping AWB"] = order.shippingAwbNumber || "";
        } else if (col.value === "origin") {
          row[col.text] = order.senderCityName || order.senderCityData || "";
        } else if (col.value === "destination") {
          row["Country"] =
            order.receiverCountryName || order.receiverCountryData || "";
          row["City"] = order.receiverCityName || order.receiverCityData || "";
          row["District"] =
            order.receiverDistrictName || order.receiverDistrictData || "";
          row["Street"] = order.receiverStreet || "";
        } else if (col.value === "receiverDetails") {
          row["Receiver Name"] = order.receiverName || "";
          row["Receiver Mobile"] = order.receiverMobile || "";
          row["Receiver Address"] =
            order.receiverAddress?.replace(/<[^>]*>/g, "") || "";
        } else if (col.value === "paymentDetails") {
          row["Payment Mode"] = order.paymentType || "";
          row["Payment Amount"] = order.codAmount || 0;
        } else if (col.value === "date") {
          row["Last Update"] = order.updatedAt
            ? new Date(order.updatedAt).toLocaleDateString()
            : "";
          row["Dispatch"] = order.drsCreatedAt
            ? new Date(order.drsCreatedAt).toLocaleDateString()
            : "";
          row["Close"] = order.closeDate || "";
        } else if (col.value === "noOfAttempt") {
          row["Attempt"] = order.deliveryAttempt || "";
          row["FD1"] = order.deliveryAttempt1 || "";
          row["FD3"] = order.deliveryAttempt2 || "";
          row["FD4"] = order.deliveryAttempt3 || "";
        } else if (col.value === "itemDetail") {
          row[col.text] =
            order.olineItems && Array.isArray(order.olineItems)
              ? order.olineItems
                  .map((item: any) => `SKU: ${item.sku}, Qty: ${item.quantity}`)
                  .join("; ")
              : "";
        } else if (col.value === "client") {
          row[col.text] = order.clientName || "";
        } else if (col.value === "status") {
          row[col.text] = order.status
            ? order.status
                .toLowerCase()
                .split("_")
                .map(
                  (word: string) =>
                    word.charAt(0).toUpperCase() + word.slice(1),
                )
                .join(" ")
            : "";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    XLSX.writeFile(wb, "orders.xlsx");

    setSelectedOrders([]);
    setIsCheckboxEnabled(false);
    setColumns((prev) =>
      prev.map((col) =>
        col.value === "select" ? { ...col, isShow: false } : col,
      ),
    );
  };

  // Determine data source based on active tab
  const isDeletedTab = activeTab === "Deleted";
  const dataSource = isDeletedTab ? deletedOrders : orders;
  const isLoading = isDeletedTab ? deletedOrderslistPending : listPending;
  const totalPages = dataSource?.totalPages ?? 0;

  return (
    <>
      {!showModal && (
        <div>
          <div className="flex items-center">
            <div className="bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px]">
              <RoleToggle
                options={tabs}
                active={activeTab}
                onChange={setActiveTab}
              />

              <div className="flex items-center gap-2">
                {dataSource && totalPages * limit > 10 && (
                  <EntriesSelector
                    value={limit}
                    options={[
                      10,
                      ...(totalPages * limit > 10 ? [20] : []),
                      ...(totalPages * limit > 20 ? [30] : []),
                      ...(totalPages * limit > 50 ? [50] : []),
                      ...(totalPages * limit > 50 ? [100] : []),
                    ]}
                    onChange={(val) => {
                      setLimit(val);
                      setPageNo(1);
                    }}
                  />
                )}
                <ColumnsFilter
                  columnsData={columns}
                  setHeadings={handleSetHeadings}
                />
                <button
                  onClick={toggleFilter}
                  className="p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
                >
                  <IconAdjustmentsHorizontal size={20} stroke={1.5} />
                </button>
                <NormalSearch
                  value={searchFor}
                  onChange={(e) => {
                    setSearchFor(e.target.value);
                    setPageNo(1);
                  }}
                />
              </div>
            </div>

            <div className="relative ml-5">
              <div className="flex items-center gap-2 justify-end rounded-full">
                <button
                  onClick={handleDownloadXLSX}
                  className={`flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] ${
                    isCheckboxEnabled && selectedOrders.length === 0
                      ? "bg-[#F7F6F2]/50 text-[#404040]/50"
                      : "bg-[#F7F6F2] text-[#404040]"
                  }`}
                >
                  <IconDownload stroke={1.5} size={24} />
                  {selectedOrders.length > 0 && (
                    <span>({selectedOrders.length})</span>
                  )}
                </button>

                {pending && (
                  <button className="flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                    <IconRefresh onClick={syncOrder} stroke={1.5} size={24} />
                  </button>
                )}
                {activeTab === "All" && !pending && (
                  <div className="relative inline-block text-left">
                    <button
                      onClick={() => navigate("/order-create-outlet")}
                      className="flex items-center gap-1 p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                      title="Create New Order"
                    >
                      <IconPlus stroke={1.5} size={24} />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {isLoading ? (
            <TableSkeleton
              columns={columns.filter((c) => c.isShow).map((c) => c.text)}
              rows={6}
            />
          ) : dataSource && dataSource.orders?.length > 0 ? (
            <>
              <AllOrderTable
                data={dataSource}
                onEdit={openEditModal}
                // onLabelPrint={handleLabelPrint}
                // onForward3PL={openForword3PlModal}
                // onReverseOrder={(item: any) => {
                //   setOrderItemId(item?.id);
                //   openReverseOrderWiseModal();
                // }}
                // openRevertModal={openRevertModal}
                // onSMS={openSmsModal}
                // onDelete={openDeleteModal}
                type={
                  activeTab === "Deleted"
                    ? "deleted"
                    : activeTab === "Cancelled"
                      ? "cancelled"
                      : "orders"
                }
                orderType={
                  pending || activeTab === "Reverse" || activeTab === "Deleted"
                }
                pending={pending}
                columnsData={columns}
                currentPage={pageNo}
                limitPage={limit}
                isCheckboxEnabled={isCheckboxEnabled}
                selectedOrders={selectedOrders}
                onSelectOrder={handleSelectOrder}
              />

              {totalPages > 1 && (
                <div className="py-4 flex justify-center">
                  <Pagination
                    totalPages={totalPages}
                    fetchData={handlePaginationFetch}
                    currentPage={pageNo}
                  />
                </div>
              )}
            </>
          ) : (
            <NoDataFound />
          )}
        </div>
      )}

      {selectedOption === "NewOrder" && showModal && (
        <AddOrdersModals
          onClose={() => setShowModal(false)}
          fetchData={refetch}
        />
      )}

      {/* Filter Sidebar */}
      {showFilter && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={toggleFilter}
          ></div>
          <div className="relative w-[400px] h-full bg-white rounded-l-3xl shadow-lg overflow-auto transition-transform duration-300 ease-in-out">
            <FilterSidebar
              setFilters={setFilters}
              refetch={activeTab === "Deleted" ? fetchDeletedOrders : refetch}
              onClose={toggleFilter}
            />
          </div>
        </div>
      )}

      {/* Modals */}

      <EditOrderModal
        open={isEditOpen}
        onClose={closeEditModal}
        order={order}
        register={register}
        errors={errors}
        setValue={setValue}
        watch={watch}
        clearErrors={clearErrors}
        handleSubmit={handleSubmit(handleUpdateOrder)}
        isPending={isUpdatePending}
      />
    </>
  );
}
